import React, { useEffect, useState } from "react";
import Loader from "../../control-components/loader/loader";
import { Dialog } from "@progress/kendo-react-dialogs";
import NotificationManager from "react-notifications/lib/NotificationManager";
import { CommonService } from "../../services/commonService";
import MultiSelectDropDown from "../../control-components/multi-select-drop-down/multi-select-drop-down";
import moment from "moment";
import { renderErrors } from "src/helper/error-message-helper";

const AttachQuestionnaire = ({
  onClose,
  clientId,
  documentId
}) => {
  const [loading, setLoading] = useState(false);
  const [questionnaireData, seQuestionnaireData] = useState([]);
  const [errors, setErrors] = useState<any>();
  const [settingError, setSettingError] = useState(false);

  let [fields, setFields] = useState({
    questionnaireName: []

  });


  useEffect(() => {
    getQuestionnaireByClientId();
  }, [])


  const getQuestionnaireByClientId = async () => {
    await CommonService.getQuestionnaireByClientId(clientId)
      .then((result: any) => {
        const list = result.resultData.map((r) => {
          return { id: r.id, questionnaire: " [" + moment.utc(r.utcDateCreated).local().format("M/D/YYYY") + "] " + r?.questionnaire };
        });
        seQuestionnaireData(list);
      })
      .catch((error) => {
        renderErrors(error.message);
      });
  };


  const saveLinkedQuestionnaire = async () => {
    setLoading(true)
    let questionIds:string[] = [];
    fields.questionnaireName.map((objType:any) => questionIds.push(objType.id));
    await CommonService.addClientQuestionnaire(documentId, questionIds)
      .then((result) => {
        NotificationManager.success("Questionnaire linked successfully");
        setLoading(false)
        onClose({ attached: true });
      })
      .catch((error) => {
        setLoading(false)
        renderErrors(error.message);
      });
  };



  const handleSubmit = () => {
    setSettingError(true);
    if (handleValidation()) {
      saveLinkedQuestionnaire();
    }
  };




  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFields({
      ...fields,
      [name]: value,
    });
  };

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;


    if (fields.questionnaireName.length == 0) {
      formIsValid = false;
      errors["questionnaireName"] = "Please select atleast one questionnaire";
    }

    setErrors(errors);
    return formIsValid;
  };
  return (
    <div>
      <Dialog
        onClose={onClose}
        title={"Add Questionnaire"}
        className="small-dailog width_90 mediumHeight questionModal blue_theme" width={"40%"} height={"55%"}
      >
        <div className="edit-client-popup">
          <div className="popup-modal slibling-data">
            <div className="">
              <div>

                <MultiSelectDropDown
                  label="Questionnaire"
                  onChange={handleChange}
                  data={questionnaireData}
                  value={fields.questionnaireName}
                  textField="questionnaire"
                  name="questionnaireName"
                  dataItemKey="id"
                  validityStyles={settingError}
                  required={true}
                  error={(fields.questionnaireName.length == 0 && errors && errors.questionnaireName) && errors.questionnaireName}
                />


              </div>
            </div>
          </div>

          {loading == true && <Loader />}
        </div>
        <div className="preview-btn-bottom">
          <div className="border-bottom-line"></div>
          <div className="d-flex my-3 buttonWidth mr-3">
            <div className="right-sde">
              <button
                className="submitButon "
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
            <div className="right-sde-grey">
              <button
                className="cancelBtn"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};
export default AttachQuestionnaire;
